<script>
import AbastractScene from '@/tbs/core/AbstractScene.vue'
import MatchInfo from '@/components/new-match-detail/MatchInfo.vue'
import { Tabs, Tab, Sticky } from 'vant'
export default {
  extends: AbastractScene,
  components: {
    MatchInfo,
    'van-tabs': Tabs,
    'van-tab': Tab,
    'van-sticky': Sticky,
  },
  data() {
    return {
      matchTopInfo: {
        id: null,
        name: null,
        logoUrl: null,
        address: null,
        totalPV: 1
      },
      matchState: {
        status: null,
        regUpdateEndDate: null,
      },
      tabsList: null,
      active: 0,
      locale: {}
    }
  },
  methods: {
    onTabClick(index) {
      this.active = index
      this.$router.push({ path: this.tabsList[index].id })
    }
  }
}
</script>

<template>
  <div class="pages-container">
    <van-sticky>
      <MatchInfo 
        :matchTopInfo="{...matchTopInfo,status: matchState?.status}"
      />
      <van-tabs v-model="active" @click="onTabClick" v-if="false">
        <van-tab v-for="(item,index) in tabsList?.tabsList" :title="item.name" :key="index" :name="item.id"></van-tab>
      </van-tabs>
    </van-sticky>
    <router-view
      class="scene-view"
      :key="Date.now()" 
      ref="sceneView"
      @custom-event="onCustomEvent" 
    />
  </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />